module.exports = __webpack_public_path__ + "static/img/banner2.7720c979.jpg";